import { IFilterSelectedStaticSet } from '@/bundles/GroupFilters/interfaces/inputs/IFilterSelectedStaticSet';

export const getStaticSetSelectFormattedValue = (value: IFilterSelectedStaticSet[]): string => {
  return value.map((set) => set.name).join(', ');
}
